import { doc } from 'prettier';

export const {
  dedent,
  group,
  hardline,
  ifBreak,
  indent,
  indentIfBreak,
  join,
  label,
  line,
  literalline,
  softline
} = doc.builders;
